<template>
    <v-row style="font-size: 1.7rem;" class="live-card player-stat-row rounded-lg px-0" align="center" justify="center">
        <v-col align="center" class="player-stat-photo py-0 my-0 px-0 mx-0">
            <img
                :src="`${assetsUrl}/${player.image}`"
                width="auto"
                height="150px"
                contain
                @error="$event.target.src = defaultPlayerImg"
            >
        </v-col>
        <v-col align="center" class="player-stat-info py-0 my-0">
            <v-row class="py-0 my-0" align="center" justify="center">
                <v-col cols="12" align="start" class="px-0 py-0 my-0">
                    <v-row class="my-0 mx-0 px-0 rounded-t-lg" style="background-color: #232323;" align="center" justify="center">
                        <v-col cols="12" class="pb-0">
                            <div class="player-line">
                                <img
                                    :src="`${assetsUrl}/${player.teamLogo}`"
                                    class="live-logo live-logo--sm"
                                    width="40px"
                                    max-height="auto"
                                    contain
                                    style="margin-right: 8px;"
                                >
                                <span v-fit-text="{ max: 1.7, min: 1, lines: 2 }" class="player-name">
                                    {{ player.name }} {{ player.surname }}
                                </span>
                                <span class="ml-2 custom-teal-text font-weight-bold player-type">
                                    {{ getType() + '%' }}
                                </span>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="center" class="py-0 my-0 pt-2">
                        <v-col cols="6" align="center" class="font-weight-bold px-0">
                            <span> {{ player.points }} </span>
                            <span class="custom-teal-text">{{ 'points' }}</span>
                            <div cols="12" align="center" class="px-0 py-0 my-0" style="font-size: 1.2rem;">
                                <span class="custom-teal-text font-weight-bold mr-1">fouls</span>
                                <span v-for="i in foulsOf(player) >= 5 ? 5 : foulsOf(player)" :key="`i-${i}`">
                                    <v-icon :color="foulsOf(player) >= 5 ? 'red' : 'teal'">mdi-minus-thick</v-icon>
                                </span>
                                <span v-for="j in ((5 - (foulsOf(player))) <= 0 ? 0 : (5 - (foulsOf(player))))" :key="`j-${j}`">
                                    <v-icon color="white">mdi-minus-thick</v-icon>
                                </span>
                            </div>
                        </v-col>
                        <v-col cols="6" align="center" class="py-0 px-0">
                            <span class="white--text" style="font-size: 1.5rem;">
                                ({{ getMade() }} / {{ getAttempts() }})
                            </span>
                            <div class="circular-border">
                                <v-progress-circular
                                    :size="90"
                                    :width="8"
                                    :value="(getMade() / getAttempts()).toFixed(2) * 100"
                                    :color="ringColor"
                                >
                                    <div class="white--text" style="font-size: 1.5rem;">
                                        {{ ((getMade() / getAttempts()).toFixed(2) * 100).toFixed(0) }}%
                                    </div>
                                </v-progress-circular>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
    import { BACKGROUNDS, matchColor, readableOn } from '@/utils/colors'
    import { foulsOf } from '@/utils/teamStats'
    import fitText from '@/utils/fitText'

    export default {
        directives: { fitText },
        props: {
            type: {
                type: String,
                default: null
            },
            player: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                assetsUrl: 'https://storage.googleapis.com',
                defaultPlayerImg: require('@/assets/default_player.png')
            }
        },
        computed: {
            // the team colour, lightened if it would vanish on the dark card
            ringColor() {
                return readableOn(matchColor(this.player) || '#03e5b7', BACKGROUNDS.dark)
            }
        },
        watch: {
            player: {
                handler() {
                    this.$forceUpdate()
                },
                deep: true,
                immediate: true
            }
        },
        methods: {
            foulsOf,
            getType() {
                if (this.type === '2P' || this.type === '3P' || this.type === '1P') {
                    return this.type
                }
                return null
            },
            getMade() {
                if (this.getType() === '2P') {
                    return this.player.twoPointsMade
                } else if (this.getType() === '3P') {
                    return this.player.threePointsMade
                } else if (this.getType() === '1P') {
                    return this.player.freeThrowsMade
                }
                return 0
            },
            getAttempts() {
                if (this.getType() === '2P') {
                    return this.player.twoPointAttempts
                } else if (this.getType() === '3P') {
                    return this.player.threePointAttempts
                } else if (this.getType() === '1P') {
                    return this.player.freeThrowAttempts
                }
                return 0
            }
        }
    }
</script>

<style>
    .v-progress-circular__info {
        display: block;
    }

    .icon-outline {
        text-shadow:
            -1px -1px 0 #000,
            1px -1px 0 #000,
            -1px  1px 0 #000,
            1px  1px 0 #000;
    }

    .circular-border {
        display: inline-flex;
        border: 2px solid #fff;     /* white border */
        border-radius: 50%;         /* make it circular */
        padding: 2px;               /* space between border and ring */
    }

    .player-line {
        display: flex;
        align-items: center;
    }

</style>

<style scoped>
    .player-stat-row {
        flex-wrap: nowrap;
        overflow: hidden;
    }

    .player-stat-photo {
        flex: 0 0 160px;
        max-width: 160px;
    }

    .player-stat-info {
        flex: 1 1 auto;
        max-width: none;
        min-width: 0;
    }

    /* never cut: a long name goes on two lines (between words) and is set smaller if it still does not fit */
    .player-name {
        position: relative;
        z-index: 1;
        flex: 0 1 auto;
        min-width: 0;
        line-height: 1.15;
    }

    .player-type {
        flex: 0 0 auto;
    }
</style>
